// extracted by mini-css-extract-plugin
export default {"root":"CategoryShortcuts_root__EcQeB","shortcut":"CategoryShortcuts_shortcut__knYdX","icon":"CategoryShortcuts_icon__yot8K","label":"CategoryShortcuts_label__9qIpT"};